// extracted by mini-css-extract-plugin
export var searchHeader = "_8d-0";
export var searchHeaderDark = "_8d-1";